var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "b-button",
        {
          staticClass: "btn-card-action btn-card-action-green my-1",
          attrs: { to: _vm.link, target: "_blank" },
        },
        [_vm._v(" Сформировать итоговый протокол ")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }